import store from '../store'
import customFontFamily from './constants/customFontFamily.js';

class CustomFont {
  constructor() {
    this.init = this.init.bind(this)
    this.textareFont = this.textareFont.bind(this)
    this.currentFontFamily = 'proxima-nova, sans-serif'
  }
  textareFont(font = 'proxima-nova, sans-serif', custom = false){
    this.currentFontFamily = font
    const css = custom ? `textarea, input, button, option, select { font-family: ${font}  }`  : `textarea, input, button, option, select { font-family: ${font + ` ,sans-serif`}  }`,
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style')

    head.appendChild(style)

    style.type = 'text/css'
    if (style.styleSheet){
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }
  }
  init() {
      const overrideFontFamilyInChatInterface = store.getters.isFontFamilyChatInterfaceOverrideEnabled
      const fontFamilyValue = store.getters.getCustomFontFamily
      const customFonts = store.state.widgetConfig?.font?.fontFamily?.customFonts || store.state.widgetConfig?.customFonts

      if (overrideFontFamilyInChatInterface) {
        if (fontFamilyValue !== 'Custom') {
          document.body.style.setProperty('font-family', customFontFamily[fontFamilyValue], 'important')
          this.textareFont(customFontFamily[fontFamilyValue], true)
        } else if (fontFamilyValue === 'Custom' && customFonts) {
          const { googleFont, FileLink = '' } = customFonts
          this.applyCustomFontFamily(googleFont, FileLink, true)
        }
        return
      }
      if(!customFonts){
        return customFonts
      }

      const {isEnable = false, fontType, googleFont, FileLink = ''} = customFonts

      if(isEnable) {
        if(fontType == 'arial' || fontType == 'helvetica') {
          document.body.style.fontFamily = fontType
          this.textareFont(fontType)
          return
        }
        if(fontType == 'CUSTOM') {
          this.applyCustomFontFamily(googleFont, FileLink)
        }
      }else {
        this.textareFont()
      }
  }

  applyCustomFontFamily(googleFont, FileLink = '', custom = false) {
    const fileLinkUrl = typeof FileLink === 'string' ? FileLink : (FileLink && FileLink.url)
    let fileLinkFamily = FileLink && typeof FileLink === 'object' ? FileLink.family : undefined
    let effectiveFamily = fileLinkFamily || (googleFont && googleFont.family)

    if (fileLinkUrl) {
      if (!effectiveFamily) {
        try {
          const last = fileLinkUrl.split('/').pop() || ''
          effectiveFamily = last.replace(/\.[^/.]+$/, '') || undefined
        } catch (e) {
          console.log(e)
        }
      }

      if (effectiveFamily) {
        const newFont = new FontFace(effectiveFamily, `url(${fileLinkUrl})`)
        newFont.load()
          .then((loadedFace) => {
            document.fonts.add(loadedFace)
          })
          .catch(() => {
            // swallow load errors to avoid breaking flow
          })
        document.body.style.fontFamily = effectiveFamily + ` ,sans-serif`
        this.textareFont(effectiveFamily, custom)
      }
      return
    }

    if(googleFont){
      const { url, family } = googleFont
      if(url && family) {
        const link = document.createElement('link')
        link.setAttribute('rel', 'stylesheet')
        link.href = url
        document.head.appendChild(link)
        document.body.style.fontFamily = family + ` ,sans-serif`
        this.textareFont(family, custom)
      }
    }
  }

  getCurrentFontFamily() {
    const overrideFontFamilyInChatInterface = store.getters.isFontFamilyChatInterfaceOverrideEnabled
    const fontFamilyValue = store.getters.getCustomFontFamily

    if (overrideFontFamilyInChatInterface) {
      if (fontFamilyValue !== 'Custom') {
        return customFontFamily[fontFamilyValue] || this.currentFontFamily || 'proxima-nova, sans-serif'
      } else {
        return store.getters.getUserDefinedFontFamily
      }
    }
    return 'proxima-nova, sans-serif'
  }
}

const customFont = new CustomFont()
export default customFont
